import Vue from 'vue'
import Vuex from 'vuex'
import auth from "./modules/auth";
import map from './modules/map';
import trip from "./modules/trip";
import {RESET_STORE} from  "./types"

let initialState = {
    trip: JSON.parse(JSON.stringify(trip.state)),
};


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        map,
        trip
    },
    mutations: {
        [RESET_STORE]: (state) => {
            Object.keys(state).forEach(key => {
                Object.assign(state[key], initialState[key]);
            })
        }
    }
})
